/**
 * Component dimensions for Gluestack props, which cannot read CSS custom properties.
 * Keep in step with the `--control-height*`, `--icon-size` and `--radius*` tokens in `index.css`.
 */
export const CONTROL_HEIGHT = {
  sm: 28,
  md: 32,
  lg: 40,
} as const;

/** Square icon tile used in page headers and empty/error states. */
export const ICON_TILE_SIZE = 32;

export const ICON_SIZE = 16;

/** Overlay elevation. Inline surfaces stay flat; only floating layers cast a shadow. */
export const SHADOW_FLOATING = '0 8px 20px rgba(16, 24, 40, 0.14), 0 1px 3px rgba(16, 24, 40, 0.08)';
